import React, { useState } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import { getCategories } from "../../../slices/productSlice";
import { updateCategory } from "../../../api/inventoryApi";
import { useDispatch } from "react-redux";



const EditCategoryList = ({ category, onClose }) => {
    const [categoryName, setCategoryName] = useState(category.name);
    const categoryId = category.id;
    const [status, setStatus] = useState(true);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const showAlert = (config) => {
        Swal.fire({
            ...config,
            icon: config.type || "success",
            confirmButtonText: "OK",
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!categoryName.trim()) {
            showAlert({
                text: "Veuillez saisir un nom de catégorie.",
                type: "warning",
            });
            return;
        }

        setLoading(true);
        try {

            const response = await updateCategory({
                name: categoryName,
                categoryStatus: status,
                id: categoryId,
                
            });

            const newCategory = response.data.category;
            dispatch(getCategories(newCategory));
            

        } catch (error) {
            const errorMessage = error.response?.data?.message || "Erreur lors de la modification.";
            showAlert({
                text: errorMessage,
                type: "error",
            });
            // alert(error);
        } finally {
            setLoading(false);
        }
    };

  return (
    <div>
      {/* Edit Category */}
      <div className="modal fade" id="edit-category">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
            <div className="modal-content">
                <div className="page-wrapper-new p-0">
                    <div className="content">
                        <div className="modal-header border-0 custom-modal-header">
                        <div className="page-title">
                            <h4>Modifier la Catégorie</h4>
                        </div>
                        <button
                            type="button"
                            className="close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                        </div>
                        <div className="modal-body custom-modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label">Nom de la catégorie</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={categoryName}
                                        onChange={(e) => setCategoryName(e.target.value)}
                                        placeholder="Entrez le nom de la catégorie"
                                    />
                                </div>
                                <div className="mb-3">
                                    <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                                        <span className="status-label">Statut</span>
                                        <input
                                            type="checkbox"
                                            id="status"
                                            checked={status}
                                            onChange={(e) => setStatus(e.target.checked)}
                                            className="check"
                                        />
                                        <label htmlFor="status" className="checktoggle"></label>
                                    </div>
                                </div>
                                <div className="modal-footer-btn">
                                    <button
                                        type="button"
                                        className="btn btn-cancel me-2"
                                        data-bs-dismiss="modal"
                                        onClick={onClose}

                                    >
                                        Annuler
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-submit"
                                        disabled={!categoryName || loading}
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        
                                    >
                                        {loading ? "Chargement..." : "Modifier"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};


// Validation des props avec PropTypes
EditCategoryList.propTypes = {
  category: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.int, 
  }),
  onClose: PropTypes.func.isRequired, 
};

export default EditCategoryList;
